import { isEmpty } from 'lodash-es';
// import PhoneNumber from 'awesome-phonenumber';

// TODO: Use an industrial phone number validator like "awesome-phonenumber" library
// => https://www.npmjs.com/package/awesome-phonenumber
// currently, it is not possible because we don't have the country code.
export const isPhone = phone => {
  if (isEmpty(phone)) return true; // empty value is allowed (using flag required instead)
  try {
    // Prefix : match 0033X, 0033(0)X, +33X, +33(0)X, 0X with X = 6 or 7
    const prefix = '(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[6-7]';
    // French number syntax : match XX XX XX XX or XX XXX XXX
    const frenchSyntax = '(?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})';
    // Other number syntax : match at least one digit
    const otherSyntax = '([\\s.-]?\\d+)';

    // Regex : match french numbers that start by prefix or all other numbers that do not start by it
    const regex = new RegExp(`^(?:${prefix}${frenchSyntax}|(?!${prefix})${otherSyntax}+)$`, 'g');

    // if (phone.match(regex).length >= 10) {
    //   const phoneNumber = PhoneNumber(phone, 'FR');
    //   return phoneNumber.isValid();
    // }
    // return false;
    return phone.match(regex).length > 0;
  } catch (error) {
    return false;
  }
};

export const isDateValid = date => {
  const regex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/i;
  const status = regex.test(date);
  return status;
};

export const isEmail = email => {
  if (isEmpty(email)) return true; // empty value is allowed (flag required)
  // eslint-disable-next-line no-useless-escape
  const regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const status = regex.test(email);
  return status;
};

export const isZIP = code => isEmpty(code) || !(code.length !== 5 || Number.isNaN(code));

export const verify = (number, size) => {
  if (isEmpty(number)) return true; // empty value is allowed (flag required)
  if (Number.isNaN(number) || number.length !== size) return false;
  let bal = 0;
  let total = 0;
  for (let i = size - 1; i >= 0; i--) {
    const step = (number.charCodeAt(i) - 48) * (bal + 1);
    /* if (step>9) { step -= 9; }
           total += step; */
    total += step > 9 ? step - 9 : step;
    bal = 1 - bal;
  }
  return total % 10 === 0;
};

export const isSIRET = siret => verify(siret, 14);

export const isSIREN = siren => verify(siren, 9);
